import {
	Avatar,
	Divider,
	Grid,
	Paper,
	Chip,
	makeStyles,
} from "@material-ui/core";
import moment from "moment";
import colorChange from "../../utils/colorChanges";

const useStyles = makeStyles((theme) => ({
	infoDiv: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "start",
		marginBottom: "10px",
	},
	infoSubDiv1: {
		display: "flex",
		gap: "0.5rem",
		alignItems: "start",
	},
	deskripsiSubDiv1: {
		fontSize: "0.9rem",
		width: "100%",
		wordWrap: "normal",
		textAlign: "justify",
	},
}));

const ColoredLine = ({ color }) => (
	<hr
		style={{
			color: color,
			backgroundColor: color,
			height: 5,
			borderColor: color,
		}}
	/>
);
export default function Comment({ comment, modalImage }) {
	const { name, deskripsi, waktu, tipe, picture, initial } = comment;
	const classes = useStyles();

	return (
		<>
			{tipe === "Notes" ? (
				<Paper style={{ padding: "1rem", marginBottom: "1rem" }}>
					<div className={classes.infoDiv}>
						<div className={classes.infoSubDiv1}>
							<Avatar alt={name}>{initial}</Avatar>
							<div>
								<div>
									<p style={{ fontWeight: "bold" }}>{name}</p>
									<p
										style={{
											fontSize: "12px",
											color: "gray",
											fontStyle: "italic",
										}}
									>
										{moment(waktu).format("MMM, DD-YYYY HH:mm")}
									</p>
								</div>
								<p className={classes.deskripsiSubDiv1}>{deskripsi}</p>
							</div>
						</div>
					</div>
					<Divider variant="fullWidth" />

					<Grid
						style={{
							display: "flex",
							flexWrap: "wrap",
							gap: "16px",
							paddingLeft: "48px",
						}}
					>
						{picture
							? picture?.map((row, index) => {
								return (
									<img
										key={index}
										alt="comments"
										onClick={() => modalImage(comment)}
										src={`${row.url_gambar}`}
										width="100px"
										style={{
											// gap: "30px",
											marginTop: "10px",
											maxWidth: "100%",
											objectFit: "scale-down",
										}}
									/>
								);
							})
							: ""}
					</Grid>
				</Paper>
			) : tipe === "Status" ? (
				<div style={{ padding: "1rem", marginBottom: "1rem" }}>
					<div className={classes.infoDiv}>
						<div className={classes.infoSubDiv1}>
							<Avatar alt={name}>{initial}</Avatar>
							<div>
								<p style={{ fontWeight: "bold" }}>{name}</p>
								<Chip
									label={deskripsi}
									size="small"
									style={{
										backgroundColor: colorChange(deskripsi).backgroundColor,
										color: colorChange(deskripsi).color,
										fontWeight: "bold",
									}}
								/>
							</div>
						</div>
						<div className={classes.infoSubDiv2}>
							<p style={{ fontSize: "12px" }}>
								{moment(waktu).format("MMM, DD-YYYY HH:mm")}
							</p>
						</div>
					</div>
					<ColoredLine color={colorChange(deskripsi).backgroundColor} />
				</div>
			) : (
				""
			)}
		</>
	);
}
